import de from './de.json';
import en from './en.json';
import es from './es.json';
import nl from './nl.json';
import tr from './tr.json';

export default {
  en,
  de,
  tr,
  es,
  nl
};
